/**
 * ****************************************************************************
 * @description     :   Store data and process common will use in page MNG_WorkReport001
 * @created at      :   2025/08/14
 * @created by      :   quanlh
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import repository from './repository';

const dataInit = {
    company_cd: '',
    company_name: '',
    department_cd: '',
    department_name: '',
    type: '',
    working_date_start: '',
    working_date_end: '',
    user_id_start: '',
    user_id_end: '',
    title_1: '',
    day_count: '',
    office_cd: '',
    office_name: '',
    message: '0',
    col: '',
    sort: ''
    // chk_all: [0]
};

export default {
    namespaced: true,
    state: {
        data: { ...dataInit },
        searchData: [],
        options: {
            message: [
                {
                    code: '0',
                    name: '未'
                },
                {
                    code: '1',
                    name: '済'
                },
                {
                    code: '3',
                    name: 'すべて'
                }
            ],
            checkbox: [
                {
                    code: 1,
                    name: ''
                }
            ]
        },
        dataSelect: {
            type: [
                {
                    code: 1,
                    name: '現場'
                },
                {
                    code: 2,
                    name: 'オフィス'
                },
                {
                    code: 4,
                    name: '営業'
                }
            ],
            title_1: [
                {
                    code: '1',
                    name: '出勤'
                },
                {
                    code: '2',
                    name: '公休'
                }
            ]
        },
        paginationData: {
            pageNo: 1,
            pageSize: 10,
            totalRows: 0,
            msgNoData: '該当するデータが存在しません。'
        }
    },
    mutations: {
        resetDataInit(state) {
            state.data = { ...dataInit };
            state.paginationData.pageNo = 1;
            state.paginationData.pageSize = 10;
            state.paginationData.totalRows = 0;
            state.paginationData.msgNoData = '該当するデータが存在しません。';
            state.searchData = [];
        },
        setSearchData(state, data) {
            state.searchData = data ?? [];
        },
        setPageNavigation(state, data) {
            state.paginationData.pageNo = parseInt(data.page);
            state.paginationData.pageSize = parseInt(data.pageSize);
            state.paginationData.totalRows = parseInt(data.totalRows);
            state.paginationData.msgNoData = parseInt(data.totalRows) == 0 ? '該当するデータが存在しません。' : '';
        },
        setCombobox(state, data) {
            if (data.company) {
                state.options.company = data.company;
            }
            if (data.department) {
                state.options.department = data.department;
            }
            if (data.status) {
                state.options.status = data.status;
            }
        }
    },
    actions: {
        actionSearch(context, request) {
            try {
                return repository.search(request.body).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        context.commit('setSearchData', data.Data.data ?? []);
                        context.commit('setPageNavigation', data.Data.paging ?? { page: 1, pageSize: 10, totalRows: 0 });
                        if (request.callback) {
                            request.callback(data);
                        }
                    } else if (request.onError) {
                        request.onError(data.Message || data.Data?.message);
                    }
                });
            } catch (e) {
                console.log('Search: ' + e.message);
                if (request?.onError) {
                    request.onError(e.message);
                }
            }
        }
    }
};
